import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import axiosInstance from "../../axiosInterceptor";

const ResetPassword = () => {
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const navigator = useNavigate();
  const [email, setEmail] = useState(location.state?.email || "");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const togglePassword2 = () => {
    setShowPassword2((prev) => !prev);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: "" });
    if (name === "email") {
      setEmail(value);
    } else if (name === "password") {
      setPassword(value);
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitAttempted(true);

    let errors = {};

    if (!email.trim()) {
      errors.email = "Email is required";
    }

    if (!password.trim()) {
      errors.password = "Password is required";
    }

    if (!confirmPassword.trim()) {
      errors.confirmPassword = "Confirm Password is required";
    } else if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords don't match";
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    try {
      const response = await axiosInstance.post(`/auth/reset-password`, {
        email,
        password,
        confirmPassword,
      });
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  return (
    <div className="container-fluid page-body-wrapper full-page-wrapper">
      <div className="content-wrapper d-flex align-items-center auth">
        <div className="row flex-grow">
          <div className="col-lg-4 mx-auto">
            <div className="auth-form-light text-left p-5">
              <h4 className="text-left">Admin Login</h4>
              <form className="pt-3" onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control form-control-sm border border-dark   "
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={handleChange}
                  />
                  {submitAttempted && errors.email && (
                    <p className="text-danger">{errors.email}</p>
                  )}
                </div>
                <div className="form-group  position-relative">
                  <input
                    className="form-control form-control-sm border border-dark   "
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="New Password"
                    value={password}
                    onChange={handleChange}
                  />

                  <span
                    className="position-absolute eye-toggle text-dark"
                    onClick={togglePassword}
                    style={{
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      zIndex: 10,
                    }}
                  >
                    {showPassword ? (
                      <Eye
                        size={20}
                        strokeWidth={1.7}
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      <EyeOff
                        size={20}
                        strokeWidth={1.7}
                        style={{ color: "#fff" }}
                      />
                    )}
                  </span>
                  {submitAttempted && errors.password && (
                    <p className="text-danger">{errors.password}</p>
                  )}
                </div>
                <div className="form-group position-relative">
                  <input
                    type={showPassword2 ? "text" : "password"}
                    className="form-control form-control-sm border border-dark   "
                    id="confirmPassword"
                    name="confirmPassword"
                    placeholder="Confirm New Password"
                    value={confirmPassword}
                    onChange={handleChange}
                  />

                  <span
                    className="position-absolute eye-toggle text-dark"
                    onClick={togglePassword2}
                    style={{
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      zIndex: 10,
                    }}
                  >
                    {showPassword2 ? (
                      <Eye
                        size={20}
                        strokeWidth={1.7}
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      <EyeOff
                        size={20}
                        strokeWidth={1.7}
                        style={{ color: "#fff" }}
                      />
                    )}
                  </span>
                  {submitAttempted && errors.confirmPassword && (
                    <p className="text-danger">{errors.confirmPassword}</p>
                  )}
                </div>

                <Link
                  to="/login"
                  className="d-flex justify-content-end align-items-center  text-decoration-none text-dark mt-4"
                >
                  <span>Back To Login</span>
                  <i
                    className="fa-solid fa-arrow-up-right-from-square ml-1"
                    style={{ fontSize: "13px" }}
                  ></i>
                </Link>

                <div className="mt-4">
                  <button
                    type="submit"
                    className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
